import { createRoutine } from 'redux-saga-routines';

export const getDashboardEmbedURL = createRoutine('GET_DASHBOARD_EMBED_URL');
export const getSessionEmbedURL = createRoutine('GET_SESSION_EMBED_URL');
